/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ScheduleSettings {
  approval_frequency?: ApprovalFrequencyEnum;
  start_from?: Date;
  approval_time?: Date;
  notify_approvers_scheduledtask_id?: string | null;
  end_cycle_scheduledtask_id?: string | null;
}
export type ApprovalFrequencyEnum = 'yearly' | 'monthly' | 'quarterly' | 'half_yearly' | 'dont_repeat';
export const ApprovalFrequencyEnum = {
  Yearly: 'yearly' as ApprovalFrequencyEnum,
  HalfYearly: 'half_yearly' as ApprovalFrequencyEnum,
  Quarterly: 'quarterly' as ApprovalFrequencyEnum,
  Monthly: 'monthly' as ApprovalFrequencyEnum,
  DontRepeat: 'dont_repeat' as ApprovalFrequencyEnum,
};
